export default __webpack_public_path__ + "static/media/IRANSansWeb_Light.b35266cb.woff";